import PropTypes from 'prop-types';
import React from 'react';
import CreativeOptions from './CreativeOptions';
import GroupOptions from './GroupOptions';
import { UserProvider } from '../hooks';
import './AdOptions.css';

const AdOptions = props => {
  const isGroup = !props.ad.action;

  return (
    <UserProvider>
      {isGroup ? (
        <GroupOptions
          group={props.ad}
          $state={props.$state}
          CreativeListService={props.CreativeListService}
          FlashService={props.FlashService}
        />
      ) : (
        <CreativeOptions
          adType={props.adType}
          creative={props.ad}
          $state={props.$state}
          CreativeListService={props.CreativeListService}
          FlashService={props.FlashService}
          ShareableLinkService={props.ShareableLinkService}
        />
      )}
    </UserProvider>
  );
};

AdOptions.propTypes = {
  ad: PropTypes.object.isRequired,

  /* 'example' when it's used on the examples list, or 'demo' when
  it's the user_creatives list (which can be single or group
  creatives) */
  adType: PropTypes.string.isRequired,

  $state: PropTypes.object.isRequired,
  CreativeListService: PropTypes.object.isRequired,
  FlashService: PropTypes.object.isRequired,
  ShareableLinkService: PropTypes.object.isRequired
};

export default AdOptions;
